import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMRoomInquiryView extends React.Component {

  constructor(props) {
    super(props);
    
    this.canRequest = true;
    this.state = {
      capacities: [],
      reservation: null,
      errors: {},
    };
    this.requestParams = this.props.requestParams;
  }

  componentDidMount() {
    $('.contact-chosen').hide();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen === true && prevProps.isOpen === false) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });
      
      SMTrackHelper.pageView(location.pathname + "/inquiry");
      mixpanel.track("Inquiry New", {"Platform" : "Web",});
    }
  }
  
  dismiss(e) {
    $(this.refs.modal).find(".md-close").click();
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.inquiryViewDidClose === 'function'){
        this.props.delegate.inquiryViewDidClose();
      }
    }
  }
  
  inquirySelectDidChange(e) {
    $('.contact-chosen').slideUp();
    $(e.currentTarget).siblings('.contact-chosen').slideDown();
  }
  
  // SMRoomInquiryView delegate
  showInquiryForm(e) {
    e.preventDefault();
    this.dismiss();
    
    if(this.props.delegate && typeof this.props.delegate.showInquiryForm === 'function'){
      this.props.delegate.showInquiryForm();
    }
  }
  
  render() {

    const room = this.props.room;
    
    return(
      <div>
        <div className="md-modal md-effect-101" ref="modal">
    			<div className="md-content">
            <div className="page__popup">
              <div className="page__popup-col1">
                <p className="page__popup__cancel search-change__cancel"><a className="md-close" onClick={this.dismiss.bind(this)} href="#"><span className="page__popup__cancel-icon search-change__cancel-icon">×</span><span>キャンセル</span></a></p>
                <div className="popup-headline">
                  <h2 className="popup-headline__title">スペースへのお問い合わせ</h2>
                  <p className="popup-headline__text">お問い合わせ内容を選択してください</p>
                </div>
                <div className="row">
                  <div key="selectForm" className="col-xs-12">
                    <div className="mb60">
                      <div className="contact-radio__area">
                        <input onChange={this.inquirySelectDidChange.bind(this)} type="radio" defaultValue="1" id="contact-radio__01" name="contact-radio" />
                        <label htmlFor="contact-radio__01" className="service-radio contact-radio">
                          <span className="contact-radio__title">スペースの詳細な情報について</span>
                          <span className="contact-radio__description">設備やアメニティの有無、飲食などスペースの使い方や収容人数についてのお問い合わせ</span>
                        </label>
                        <div className="contact-chosen">
                          <ul className="contact-chosen__list">
                            <li>日程が決まっている場合は、<a href={Routes.space_room_reservations_path(room.space.username, room.uid)} className="a__underline">予約カレンダー画面</a> からご希望の日程を選択し、
                              「お問い合わせ事項」の欄に不明点を記入の上、予約リクエストを送信してください。ホストが確認後、回答します。</li>
                            <li>日程が未定の場合は、<a href="#" onClick={this.showInquiryForm.bind(this)} className="a__underline">お問い合わせフォーム</a> に必要事項を記入後送信してください。（※アカウント登録/ログインが必要です）</li>
                            <li>電話連絡などが必要な場合は、<a href={Routes.concierge_index_path()} className="a__underline">コンシェルジュサービス</a> よりスペースマーケットにお問い合わせ下さい。</li>
                          </ul>
                        </div>
                      </div>
                      <div className="contact-radio__area">
                        <input onChange={this.inquirySelectDidChange.bind(this)} type="radio" defaultValue="2" id="contact-radio__02" name="contact-radio" />
                        <label htmlFor="contact-radio__02" className="service-radio contact-radio">
                          <span className="contact-radio__title">空き状況の確認・日程について</span>
                          <span className="contact-radio__description">空き状況や予約カレンダーの内容についてのお問い合わせ</span>
                        </label>
                        <div className="contact-chosen">
                          <ul className="contact-chosen__list">
                            <li><a href={Routes.space_room_reservations_path(room.space.username, room.uid)} className="a__underline">予約カレンダー画面</a> からご希望の日程を選択し、
                              「お問い合わせ事項」の欄に確認の旨を記入の上、予約リクエストを送信してください。ホストが確認後、回答します。</li>
                            <li>複数のスペースの日程確認や電話連絡が必要な場合は、<a href={Routes.concierge_index_path()} className="a__underline">コンシェルジュサービス</a> よりスペースマーケットにお問い合わせください。</li>
                          </ul>
                        </div>
                      </div>
                      <div className="contact-radio__area">
                        <input onChange={this.inquirySelectDidChange.bind(this)} type="radio" defaultValue="3" id="contact-radio__03" name="contact-radio" />
                        <label htmlFor="contact-radio__03" className="service-radio contact-radio">
                          <span className="contact-radio__title">定期利用、長期利用について</span>
                        </label>
                        <div className="contact-chosen">
                          <ul className="contact-chosen__list">
                          <li>スペースの定期利用、長期利用についてのご相談は、まずスペースマーケットの <a href={Routes.concierge_index_path()} className="a__underline">コンシェルジュサービス</a> までお問い合わせください。専任のスタッフがご相談を承ります。</li>
                          </ul>
                        </div>
                      </div>
                      <div className="contact-radio__area">
                        <input onChange={this.inquirySelectDidChange.bind(this)} type="radio" defaultValue="4" id="contact-radio__04" name="contact-radio" />
                        <label htmlFor="contact-radio__04" className="service-radio contact-radio">
                          <span className="contact-radio__title">内覧や見学について</span>
                        </label>
                        <div className="contact-chosen">
                          <ul className="contact-chosen__list">
                            <li>日程が決まっている場合は、<a href={Routes.space_room_reservations_path(room.space.username, room.uid)} className="a__underline">予約カレンダー画面</a> からご希望の日程を選択し、
                              「お問い合わせ事項」の欄に内覧・見学についての詳細を記入の上、予約リクエストを送信してください。ホストが確認後、回答します。</li>
                            <li>日程が未定の場合は、<a href="#" onClick={this.showInquiryForm.bind(this)} className="a__underline">お問い合わせフォーム</a> に必要事項を記入後送信してください。（※アカウント登録/ログインが必要です）</li>
                            <li>また複数のスペースをご検討中の場合は、<a href={Routes.concierge_index_path()} className="a__underline">コンシェルジュサービス</a> をご利用ください。スペースマーケットのスタッフがサポートいたします。</li>
                          </ul>
                        </div>
                      </div>
                      <div className="contact-radio__area">
                        <input onChange={this.inquirySelectDidChange.bind(this)} type="radio" defaultValue="5" id="contact-radio__05" name="contact-radio" />
                        <label htmlFor="contact-radio__05" className="service-radio contact-radio">
                          <span className="contact-radio__title">電話連絡を希望</span>
                        </label>
                        <div className="contact-chosen">
                          <ul className="contact-chosen__list">
                            <li>スペースマーケットの <a href={Routes.concierge_index_path()} className="a__underline">コンシェルジュサービス</a> までお問い合わせください。</li>
                          </ul>
                        </div>
                      </div>
                      <div className="contact-radio__area">
                        <input onChange={this.inquirySelectDidChange.bind(this)} type="radio" defaultValue="6" id="contact-radio__06" name="contact-radio" />
                        <label htmlFor="contact-radio__06" className="service-radio contact-radio">
                          <span className="contact-radio__title">その他</span>
                          <span className="contact-radio__description">上記のいずれにも当てはまらない場合。</span>
                        </label>
                        <div className="contact-chosen">
                          <ul className="contact-chosen__list">
                            <li>日程が決まっている場合は、<a href={Routes.space_room_reservations_path(room.space.username, room.uid)} className="a__underline">予約カレンダー画面</a> からご希望の日程を選択し、「お問い合わせ事項」の欄に詳細を記入の上、予約リクエストを送信してください。ホストが確認後、回答します。</li>
                            <li>日程が未定の場合は、<a href="#" onClick={this.showInquiryForm.bind(this)} className="a__underline">お問い合わせフォーム</a> に必要事項を記入後送信してください。（※アカウント登録/ログインが必要です）</li>
                          </ul>
                        </div>
                      </div>
                    </div>                  
                  </div>                  
                </div>
              </div>
            </div>
          </div>
    		</div>
        <div className="md-overlay"></div>
      </div>
    );
  }

}
export default SMRoomInquiryView;



// WEBPACK FOOTER //
// ./app/javascript/components/rooms/SMRoomInquiryView.jsx